import React from 'react';
import { useTranslation } from 'react-i18next';
import c from 'classnames';
import AdoptableCountdown from '@wix/da-ds/pkg/Time/AdoptableCountdown';
import s from './Countdown.scss';
function getLabelTranslation(t, hasEnded, isEarlyAccess) {
    if (hasEnded) {
        return t('sidebar.exclusives.countdown.label.ended');
    } else if (isEarlyAccess) {
        return t('sidebar.exclusives.countdown.label.earlyAccessTimer');
    } else {
        return t('sidebar.exclusives.countdown.label.offerTimer');
    }
}
const Countdown = ({ countToDate, onEnd, isEarlyAccess, hasEnded, className })=>{
    const { t } = useTranslation();
    return /*#__PURE__*/ React.createElement("div", {
        className: c(s['root'], className)
    }, /*#__PURE__*/ React.createElement("div", {
        className: s['label']
    }, getLabelTranslation(t, hasEnded, isEarlyAccess)), /*#__PURE__*/ React.createElement("div", {
        className: s['value']
    }, /*#__PURE__*/ React.createElement(AdoptableCountdown, {
        countToDate: countToDate,
        endedClassName: s['ended'],
        endedMessage: `00:00:00`,
        onEnd: onEnd
    })));
};
Countdown.displayName = 'Countdown';
export default Countdown;

//# sourceMappingURL=Countdown.js.map